import { useState } from 'react';
import React from 'react';
import axios from 'axios';
import { apiUrl } from '../config/Config';
import logo from '../assets/images/hagnostechlogo.webp';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
const Home = () => {



const dispatch = useDispatch();
    // // State for username and password inputs
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [showloding, setshowloding] = useState(false);
    const navigate = useNavigate();
    // This function runs when you click the "Login" button



    const loginpressed = async() => {
        // navigate('/customer/home');
        if(username && password) {
          setshowloding(true);
          var data = {
              'username' : username,
              'password': password
          }
          const headers = {
              headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*'
              }
          }
          let resp = await axios.post(apiUrl + 'adminlogin', data, headers).then((res) => {
              if(res.data.status == 'success') {
                dispatch({ type: "userdata", payload: res.data.data });
                var prevdata = res.data.data;
                if(prevdata?.metatoken) {
                    navigate('/admin/dashboardtest');
                } else {
                    navigate('/admin/dashboardtest');
                }
                
                console.log(res.data.data);
              } else {
                alert(res.data.message);
              }
          } ).catch((err) => {
              alert(err.message)
          })
          setshowloding(false);
      } else {
          alert('username and password is required');
      }
      }  
  

    return (
        <div>
            <section className="container">
                <div className="login-section">
                   

                        <div className="loginBoxMaindiv">
                            <div className="loginBox webloginBox">
                                <img src={logo} />
                                <div className="mb-3 mt-4">
                                    <label for="username" className="form-label">
                                        Username:
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Username"
                                        className="form-control logininput"
                                        value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>
                                <div className="mb-4 ">
                                    <label for="pwd" className="form-label">
                                        Password:
                                    </label>
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        className="form-control logininput"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className='mb-2'>
                                    <button type="submit  " onClick={() => {loginpressed()}} className="btn btn-primary webcustom-btn">  Login</button>
                                    {message && <p className="message">{message}</p>}
                               
                                </div>


                            </div>
                        </div>
                

                </div>
            </section>


        </div>
    )
};

export default Home;